import { Table, Button, Row, Col, Form, Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Message from './../components/Message';
import Loader from './../components/Loader';
import { useGetOpeningStocksQuery, useDeleteOpeningStockMutation } from './../slices/openingStocksApiSlice';
import { toast } from 'react-toastify';
import { useState } from 'react';


const StaffOpeningStock = () => {
  // State for filtering, pagination, and date range
  const [filter, setFilter] = useState('');
  const [pageNumber, setPageNumber] = useState(1);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  // Fetch paginated openingStocks data
  const { data, isLoading, error, refetch } = useGetOpeningStocksQuery(pageNumber);

  // Mutation for deleting openingStocks
  const [deleteOpeningStock, { isLoading: loadingDelete }] = useDeleteOpeningStockMutation();

  // Handle openingStock deletion
  
  const deleteHandler = async (id) => {
    if (window.confirm('Are you sure you want to delete this openingStock?')) {
      try {
        await deleteOpeningStock(id).unwrap();
        toast.success('OpeningStock deleted successfully!');
        refetch(); // Refetch openingStocks after successful deletion
      } catch (err) {
        toast.error(err?.data?.message || 'Failed to delete openingStock.');
      }
    }
  };

  // Filter openingStocks data based on product name, note, and date range
  const filterOpeningStocks = () => {
    if (!data?.openingStocks) return [];
    return data.openingStocks.filter((openingStock) => {
      const openingStockDate = new Date(openingStock.date);
      const isWithinDateRange =
        (!startDate || openingStockDate >= new Date(startDate)) &&
        (!endDate || openingStockDate <= new Date(endDate));
      return (
        isWithinDateRange &&
        (openingStock.note?.toLowerCase().includes(filter.toLowerCase()) || // Check note
          openingStock.openingStockItems.some((item) =>
            item.name.toLowerCase().includes(filter.toLowerCase()) // Check product name
          ))
      );
    });
  };

  // Calculate total openingStocks
  const calculateTotalOpeningStocks = () => {
    return filterOpeningStocks().reduce((total, openingStock) => {
      const openingStockTotal = openingStock.openingStockItems.reduce(
        (subTotal, item) => subTotal + item.qty * item.price,
        0
      );
      return total + openingStockTotal;
    }, 0);
  };

  // Handle pagination changes
  const paginationHandler = (page) => {
    setPageNumber(page);
  };

  return (
    <>
      <Row className="align-items-center mb-3">
        <Col>
          <h1>OpeningStocks</h1>
        </Col>
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Filter by product name or note"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Col>
      </Row>

      <Row className="mb-3">
        <Col md={3}>
          <Form.Control
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            placeholder="Start Date"
          />
        </Col>
        <Col md={3}>
          <Form.Control
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            placeholder="End Date"
          />
        </Col>
        <Col md={6} className="text-end">
          <h4>Total OpeningStocks: {calculateTotalOpeningStocks().toFixed(2)}</h4>
        </Col>
      </Row>

      {loadingDelete && <Loader />}
      {isLoading ? (
        <Loader />
      ) : error ? (
        <Message variant="danger">
          {error?.data?.message || 'An error occurred'}
        </Message>
      ) : (
        <>
          <Table striped bordered hover responsive className="table-sm">
            <thead>
              <tr>
                <th>DATE</th>
                <th>PRODUCT NAME</th>
                <th>QTY</th>
                <th>TOTAL</th>
                <th>NOTE</th>
                <th>IMAGE</th>
                <th>ACTIONS</th>
              </tr>
            </thead>
            <tbody>
              {filterOpeningStocks().map((openingStock) =>
                openingStock.openingStockItems.map((item) => (
                  <tr key={`${openingStock._id}-${item.product}`}>
                    <td>{new Date(openingStock.date).toLocaleDateString()}</td>
                    <td>{item.name}</td>
                    <td>{item.qty}</td>
                    <td>{(item.qty * item.price).toFixed(2)}</td>
                    <td>{openingStock.note || 'N/A'}</td>
                    <td>
                      {item.images && (
                        <img
                          src={item.images[0]}
                          alt="Thumbnail"
                          className="thumbnail-img me-2"
                          style={{
                            width: '10px',
                            height: '10px',
                            objectFit: 'cover',
                            borderRadius: '5px',
                          }}
                        />
                      )}
                    </td>
                    <td>
                      <Button
                        as={Link}
                        to={`/openingStock/${openingStock._id}`}
                        variant="light"
                        className="btn-sm"
                      >
                        Details
                      </Button>
                      <Button
                         style={{ display: 'none' }}
                                              as={Link}
                                              to={`/admin/openingStock/${openingStock._id}/edit`}
                                              variant="light"
                                              className="btn-sm mx-2"
                                            > 
                                            Edit
                                            </Button>
                      <Button
                        style={{ display: 'none' }}
                        variant="danger"
                        className="btn-sm mx-2"
                        onClick={() => deleteHandler(openingStock._id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          <Pagination>
            {[...Array(data.pages).keys()].map((x) => (
              <Pagination.Item
                key={x + 1}
                active={x + 1 === pageNumber}
                onClick={() => paginationHandler(x + 1)}
              >
                {x + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </>
      )}
    </>
  );
};

export default StaffOpeningStock;